import React from "react"
import FoodCategories from "./Food_Categories"

const FoodCategorySelection = (props) => {
  return <FoodCategories {...props} />
}

export default FoodCategorySelection
